import loadable from '@loadable/component';

export const LazyPreviewListener = loadable(() => import(/* webpackChunkName: "content/guest/site/previewlistener" */ './PreviewListener'));
